export const DEFAULT_POSTHOG_PROXY_HOST = "https://z.repackify.com";

export function posthogProxyHost(configured: string | undefined): string {
  const trimmed = configured?.trim();
  return trimmed ? trimmed : DEFAULT_POSTHOG_PROXY_HOST;
}

export function posthogReportEndpoint(proxyHost: string, projectToken: string | undefined): string | null {
  const token = projectToken?.trim();
  return token ? `${proxyHost}/report/?token=${token}` : null;
}
